var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:`message-container message-container-${_vm.type}`,style:(_vm.positionStyle)},[_c('div',[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }